export default __webpack_public_path__ + "media/0664e9107e02c9117c3fdd7eda9a9dfc09386ac9d2761c1d22afea136d0df27c.svg";